import { SITE_ID } from './site-id';

/**
 * 予約詳細からチェックインに入ってくる際のパラメータ
 * @param searchType　検索方法選択
 * @param orderId　予約番号
 * @param eTicketNumber 航空券番号
 * @param firstName　搭乗者名（名）
 * @param lastName 搭乗者名（姓）
 * @param journeyID JourneyID
 * @param flightIds セグメントIDリスト
 * @param SITE_ID 連携サイトID
 */
export interface ParameterFromServicing {
  /** 検索方法選択 */
  searchType?: 'order' | 'eTicket';
  /** 予約番号 */
  orderId?: string;
  /** 航空券番号　*/
  eTicketNumber?: string;
  /** 搭乗者名（名） */
  firstName?: string;
  /** 搭乗者名（姓） */
  lastName?: string;
  /** JourneyID */
  journeyID?: string;
  /** セグメントIDリスト */
  flightIds?: string[];
  /** 連携サイトID */
  SITE_ID?: keyof Pick<typeof SITE_ID, 'ASW_TOP' | 'RESERVATION'>;
}

/**
 * 予約詳細からチェックインに遷移する際のパラメータを受け渡すセッションストレージ名
 */
export const SESSION_STORAGE_KEY_FROM_SERVICING = 'servicingMybookingToCheckin';
